type MediaClock = EventTarget & { currentTime: number; paused: boolean; seeking: boolean; readyState: number }
type MediaSyncControls = {
  isPlaying: () => boolean
  pauseAt: (seconds: number) => void
  resumeAt: (seconds: number) => Promise<void>
  onError: (error: unknown) => void
}

export function bindEditorMediaSync(video: MediaClock, controls: MediaSyncControls) {
  let suspended = false
  let resuming = false
  let disposed = false
  const wait = () => {
    if (disposed || !controls.isPlaying()) return
    suspended = true
    controls.pauseAt(video.currentTime)
  }
  const ready = () => {
    if (disposed || !suspended || resuming || video.paused || video.seeking || video.readyState < 2) return
    resuming = true
    void controls.resumeAt(video.currentTime).then(() => {
      if (disposed) return
      if (video.paused || video.seeking || video.readyState < 2) {
        controls.pauseAt(video.currentTime)
        return
      }
      suspended = false
    }).catch(controls.onError).finally(() => { resuming = false })
  }
  for (const name of ["waiting", "seeking"]) video.addEventListener(name, wait)
  for (const name of ["playing", "seeked"]) video.addEventListener(name, ready)
  return {
    isSuspended: () => suspended,
    dispose: () => {
      disposed = true
      suspended = false
      for (const name of ["waiting", "seeking"]) video.removeEventListener(name, wait)
      for (const name of ["playing", "seeked"]) video.removeEventListener(name, ready)
    },
  }
}
